<template>
  <div class="private-content" :class="{'submenu-reduced': !contentSubmenuReduceSidebar}">
    <custom-content
      v-if="!isAuthenticated"
      :isDesktop="isDesktop"
      :displayCloseBtn="false"
      @open-register="$emit('open-register')"
    />
    <template v-if="isAuthenticated">
        <private-content-user-free 
          v-if="isProfileFree"
          :isDesktop="isDesktop"
          :displayCloseBtn="false"
          @open-my-account="openMyAccount"
          @open-attendance="openAttendance">
        </private-content-user-free>
        <private-content-user-demo
          v-if="isProfileDemo"
          :isDesktop="isDesktop"
          :displayCloseBtn="false"
          @open-plans="openPlans"
          @open-attendance="openAttendance">
        </private-content-user-demo>
        <private-content-user-subscriber 
          v-if="isProfileSubscriber"
          :isDesktop="isDesktop"
          :displayCloseBtn="false"
          @open-plans="openPlans"
          @open-attendance="openAttendance">
        </private-content-user-subscriber>
    </template>
  </div>
</template>

<script>
import AppConstants from '../../../appConstants';
import { EventBus } from '../../../event-bus';
import CustomContent from "../CustomContent.vue";
import PrivateContentUserDemo from './PrivateContentUserDemo.vue';
import PrivateContentUserFree from './PrivateContentUserFree.vue';
import PrivateContentUserSubscriber from './PrivateContentUserSubscriber.vue';

export default {
  data() {
    return {
    }
  },
  components: {
    CustomContent,
    PrivateContentUserFree,
    PrivateContentUserDemo,
    PrivateContentUserSubscriber
  },
  computed: {
    contentSubmenuReduceSidebar() {
      return this.$store.state.contentSubmenuReduceSidebar;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    userProfile() {
      return this.$store.state.AppActiveUser.profile;
    },
    isProfileFree() {
        return this.userProfile == AppConstants.USER_PROFILE.FREE;
    },
    isProfileDemo() {
        return this.userProfile == AppConstants.USER_PROFILE.DEMO;
    },
    isProfileSubscriber() {
        return this.userProfile == AppConstants.USER_PROFILE.SUBSCRIBER;
    }
  },
  methods: {
    openAttendance() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE);
    },
    openMyAccount() {
      if (!this.isDesktop) {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_SIGNATURES_MOBILE);
        this.$emit('close');
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_SIGNATURE);
    },
    openPlans() {
      if (!this.isDesktop) {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLANS_MOBILE);
        this.$emit('close');
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT_PLANS);
    },
  }
};
</script>
